__turbopack_context__.v({
  "backdrop": "styles-module-scss-module__BAdSpq__backdrop",
  "backdropFadeIn": "styles-module-scss-module__BAdSpq__backdropFadeIn",
  "closeContainer": "styles-module-scss-module__BAdSpq__closeContainer",
  "closeIcon": "styles-module-scss-module__BAdSpq__closeIcon",
  "closeTitle": "styles-module-scss-module__BAdSpq__closeTitle",
  "contentWrapper": "styles-module-scss-module__BAdSpq__contentWrapper",
  "headerLeft": "styles-module-scss-module__BAdSpq__headerLeft",
  "scrollContent": "styles-module-scss-module__BAdSpq__scrollContent",
  "scrollableContent": "styles-module-scss-module__BAdSpq__scrollableContent",
  "slideIn": "styles-module-scss-module__BAdSpq__slideIn",
  "slideInContent": "styles-module-scss-module__BAdSpq__slideInContent",
});
